import { useTranslation } from "@opendash/i18n";
import { stringToTag } from "@opendash/ui";
import { Descriptions } from "antd";
import { DescriptionsItemType } from "antd/lib/descriptions";
import { observer } from "mobx-react-lite";
import React from "react";
import { ProjectTag, TicketStateTag, useTicketData } from "../../..";

export const TicketOverviewCard = observer(() => {
  const t = useTranslation();
  const ticketData = useTicketData();

  const items: DescriptionsItemType[] = [
    {
      label: t("maintenance:general.label.source"),
      children: stringToTag(
        `'${ticketData?.source?.get("name") ?? t("maintenance:general.label.sourceNotFound")}'`,
        "'"
      ),
      span: 2,
    },
    {
      label: t("maintenance:general.label.state"),
      children: <TicketStateTag state={ticketData?.state} />,
    },
    {
      label: t("maintenance:general.label.project"),
      children: <ProjectTag />,
    },
  ];

  return <Descriptions items={items} bordered column={4} size="middle" />;
});
